import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AbstractService } from './abstract.service';

@Injectable({
    providedIn: 'root'
})
export class EstacaoService extends AbstractService {

    constructor(http: HttpClient) {
        super('v1/estacao', http);
    }

    getTotalizadores(uf = null) {
        let rota = 'totalizadores';
        if (uf) {
            rota = 'totalizadores/' + uf;
        }
        return this.getOne(rota);
    }

    getQuantidadePorPoluente(uf = null) {
        let rota = 'quantidadePorPoluente';
        if (uf) {
            rota = 'quantidadePorPoluente/' + uf;
        }
        return this.getOne(rota);
    }

    getQuantidadePorTipo(uf = null) {
        let rota = 'quantidadePorTipo';
        if (uf) {
            rota = 'quantidadePorTipo/' + uf;
        }
        return this.getOne(rota);
    }

    getQuantidadePorSituacao(uf = null) {
        let rota = 'quantidadePorSituacao';
        if (uf) {
            rota = 'quantidadePorSituacao/' + uf;
        }
        return this.getOne(rota);
    }

    getEstacoesPorId(id = null) {
        let rota = 'buscarEstacoes';
        if (id) {
            rota = 'buscarEstacoes?codigoEstacao=' + id;
        }
        return this.getOne(rota);
    }

    getEstacaoDetalhada(id = null, data?: string) {
        let rota = 'detalhada';
        if (id) {
            rota = 'detalhada/' + id;
        }

        if (data) {
            rota = rota + `?data=${data}`;
        }
        return this.getOne(rota);
    }


    filtroEstacoes(page = 0, size = 10, filter: any) {
        let params = new HttpParams();
        params = params.set('page', page.toString());
        params = params.set('size', size.toString());
        if (filter.uf && filter.uf != 'Todos') {
            params = params.set('uf', filter.uf);
        }
        if (filter.municipio) {
            params = params.set('idMunicipio', filter.municipio );
        }
        if (filter.estacao) {
            params = params.set('nomeEstacao', filter.estacao );
        }
        return this.filterByParam(params, 'buscarEstacoes');
    }

}
